import Phaser from 'phaser';

import { BootScene } from './scenes/BootScene.js';
import { GameScene } from './scenes/GameScene.js';
import { LobbyScene } from './scenes/LobbyScene.js';

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  width: window.innerWidth,
  height: window.innerHeight,
  backgroundColor: '#0b0b0f',
  scene: [BootScene, LobbyScene, GameScene],
  dom: { createContainer: true },
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
});

// Expone hooks de test (Playwright TKT-010) sin filtrar a producción.
if (import.meta.env.MODE !== 'production') {
  (window as unknown as { __trames__?: unknown }).__trames__ = { game };
}
